// eslint-disable-next-line
import styled from 'styled-components';

export const Base = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2x);
  margin-bottom: var(--spacing-4x);
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2x);
`;

export const ChecboxGroupBox = styled.div`
  display: flex;
  align-items: center;
`;

export const StructureInput = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-2x);
`;

export const CheckboxGroupLink = styled.a`
  text-decoration: underline;
  cursor: pointer;
  margin-left: var(--spacing-half);
  font: var(--_label-md-1-font);
  letter-spacing: var(--_label-md-1-letter-spacing);
`;
